import type { ReactNode } from 'react';
import { ArrowRight, LoaderCircle, ShieldCheck } from 'lucide-react';
import { useAuth } from './AuthProvider';

export function AuthGate({ children }: { children: ReactNode }) {
  const auth = useAuth();
  if (auth.status === 'loading') {
    return <div className="auth-screen"><LoaderCircle className="size-8 animate-spin" /><p>ログイン状態を確認しています</p></div>;
  }
  if (auth.status === 'authenticated') return children;
  return (
    <main className="auth-screen px-6">
      <section className="auth-card">
        <div className="filo-mark" aria-hidden="true"><span /><span /><span /></div>
        <p className="eyebrow">ROBOT FLOW STUDIO</p>
        <h1>Filo</h1>
        <p className="auth-copy">ロボットの動きを組み立て、つながっている仲間へ一斉に届けます。</p>
        {auth.error && <p className="auth-error" role="alert">{auth.error}</p>}
        <button className="auth-button" onClick={() => void auth.signIn()}>
          <ShieldCheck className="size-5" />
          Filoへログイン
          <ArrowRight className="ml-auto size-5" />
        </button>
        <p className="auth-note">アカウントは管理者が発行します。</p>
      </section>
    </main>
  );
}
